export default function check_for_list_feedback (result) {
    if (result === [] || result === "[]") return [];
    else if (result.elements === "[]") return [];
    return result.elements;
}